/*
* 2016 Studio Aquion
*
*  @author    Studio Aquilon
*  @copyright 2016 Studio Aquilon
*  @license   not for sale excepted on Prestashop Addons with Szczepaniak Xavier's permission
*/

import $ from 'jquery';
import '../lib/slick.min';
import InitPhotoswipe from '../lib/photoswipe-init';

export default class InitSlider {

  constructor(photoswipe){
    this.productSliderSettings = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      infinite: false,
      asNavFor: '.product-slider-nav'
    };
    this.productSliderNavSettings = {
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.product-slider',
      dots: false,
      focusOnSelect: true,
      swipeToSlide: true,
      centerPadding: '50px',
      centerMode: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
            arrows: false,
            centerPadding: '50px'
          }
        },
        {
          breakpoint: 400,
          settings: {
            slidesToShow: 3,
            arrows: false,
            centerPadding: '30px'
          }
        }
      ]
    };


    var elNav = $('.product-slider-nav');
    var slideTotal;


    // init method
    elNav.on('init reInit', function (event, slick){
      slideTotal = slick.slideCount;
    });
    // init
    $('.product-slider').slick(this.productSliderSettings);
    elNav.slick(this.productSliderNavSettings);
    // go to cover image
    var slideIndex = $('.product-slider-nav .slick-slide[data-sa="cover"]').data('slick-index');
    elNav.slick('slickGoTo', Math.abs(slideIndex), false);
    $('.pre-slick-slide').css('opacity','1');
    // reconfig
    if (slideTotal == 1) {
      elNav.slick('slickRemove', 0);
    }
    /*if (slideTotal == 2){
      elNav.slick('slickSetOption', 'centerMode', false, true);
      $('.slick-track').addClass('nocentermode');
    }
    if (slideTotal == 3){
      elNav.slick('slickSetOption', 'centerMode', false, true);
      $('.slick-track').addClass('nocentermode');
      elNav.slick('slickSetOption', 'infinite', true, true);
    }*/

    if (slideTotal >= 2){
      elNav.slick('slickSetOption', 'centerMode', false, true);
      $('.slick-track').addClass('nocentermode');
    }

    // Photoswipe
    if (photoswipe){
      $('.product-slider').on('click', function(slick){
        var index = $('.slick-active').data('slick-index');
        var initPhotoswipe = new InitPhotoswipe(index,slick);
        
        initPhotoswipe.listen('afterChange', function() {
          $('.product-slider').slick('slickGoTo', Math.abs(initPhotoswipe.getCurrentIndex()), true);
        });
      });
    }

  }

}







// WEBPACK FOOTER //
// ./js/lib/slick-init.js